import { render, staticRenderFns } from "./AdminStatistics.vue?vue&type=template&id=aecb2554&scoped=true&"
import script from "./AdminStatistics.vue?vue&type=script&lang=js&"
export * from "./AdminStatistics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aecb2554",
  null
  
)

export default component.exports